import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useLoader } from '../api/useLoader';
import { StudiestedApiContext } from '../api/StudiestedApiContext';
import { useParams } from 'react-router-dom';
import Spinner from '../components/spinner/spinner';
import PageLayout from '../pagelayout';
import * as css from './userprofile.module.scss';
import { Grid } from '@mui/material';
import translations from './userprofile.i18n';
import { SelectedRoleContext } from '../providers';

const StudentbrukerprofilPageLayoutWrapper = () => {
  const { name: institution } = useContext(SelectedRoleContext)!;
  const { formatMessage } = useIntl();

  const labels = {
    title: formatMessage(
      { id: translations.titleStudent.id },
      { institusjon: institution },
    ),
    subtitle: formatMessage({ id: translations.subtitle.id }),
  };

  return (
    <PageLayout isIndented title={labels.title} subtitle={labels.subtitle}>
      <StudentbrukerprofilPage />
    </PageLayout>
  );
};

const getInitials = (fornavn: string, etternavn: string) => {
  let initials = '';
  for (const name of `${fornavn} ${etternavn}`.split(/\s+/)) {
    initials += name[0];
  }
  return initials;
};

const StudentbrukerprofilPage = () => {
  const { studiestedApi } = useContext(StudiestedApiContext);
  const { id } = useParams<{ id: string }>();

  const { formatMessage } = useIntl();

  const { data, loading } = useLoader(
    () =>
      studiestedApi.studentbrukerprofilIdGet({
        pathParams: { id: id as string },
      }),
    [id],
    true,
    true,
  );

  const labels = {
    tilbake: formatMessage({ id: translations.tilbake.id }),
    telefon: formatMessage({ id: translations.telefon.id }),
    epost: formatMessage({ id: translations.epost.id }),
  };

  if (loading) return <Spinner />;
  if (!data || !id) return <></>;

  const { fornavn, etternavn, epost, telefonnummer } = data.bruker;

  const initials = getInitials(fornavn, etternavn);

  return (
    <Grid container className={css.container}>
      <Grid item xs={3}>
        <div className={css.profilePictureReplacement}>{initials}</div>
      </Grid>
      <Grid item xs={8}>
        <Grid container>
          <Grid item xs={12}>
            <span className={css.name}>{`${fornavn} ${etternavn}`}</span>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={4}>
                <span>
                  <span className={css.label}>{labels.telefon}</span>
                  {telefonnummer}
                </span>
              </Grid>
              <Grid item xs={4}>
                <span>
                  <span className={css.label}>{labels.epost}</span>
                  {epost}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StudentbrukerprofilPageLayoutWrapper;
